
import { FormAjax }  from './components/Form'
import  InteractiveMap  from './components/Map'

customElements.define('form-ajax', FormAjax, { extends: "form" })
customElements.define('interactive-map', InteractiveMap)
